import React, { Component } from 'react';
import Footer from '../components/Footer.jsx';
import Navbar from '../components/Navbar.jsx';
import Jumbotron from '../components/Jumbotron.jsx';

class Contact extends Component {
  render() {
    return (
      <div style={{'background-color': ""}}>
          <div className='contactTitleContainer' style={{'width':'100%', 'height': "100px", 'backgroundColor': '#f1a38e', 'color': 'white'}}>
          <p style={{'marginLeft':'7%', fontSize: '45px'}}>Contact us</p>
          <div style={{'marginLeft':'7%', 'marginTop': '-20px'}}>Please contact me at <a href="mailto:badeladhambharatvarsh@gmail.com" style={{ color: '#0066cc' }}>badeladhambharatvarsh@gmail.com</a></div></div>
            <div className="container" style={{'minHeight': "550px", marginTop: '2%'}}>
            <p>If you have any query related to  बड़ेला धाम भारतवर्ष feel free to contact me by drop me email.</p>
            <p>E-Mail : <a href="mailto:badeladhambharatvarsh@gmail.com" style={{ color: '#0066cc' }}>badeladhambharatvarsh@gmail.com</a></p>
            Here We are on Facebook : <a style={{color:'blue'}} href='https://www.facebook.com/badeladham' >बड़ेला धाम भारतवर्ष</a><br></br><br></br>
            
            Here We are on YouTube :  <a style={{color:'blue'}} href='https://www.youtube.com/@BadelaDhamBharatvarsh' >बड़ेला धाम भारतवर्ष</a>
            <br></br><br></br>
            
            <p>If you haven't joined us, this is the right time to join us.</p>

          <div>
                
          </div>
        </div>
      </div>
    );
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/pages/Contact.jsx